export type MetaBrowserContext = {
  event_id: string;
  fbp?: string;
  fbc?: string;
  source_url: string;
};

type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}

const rawPixelId = (import.meta.env.VITE_META_PIXEL_ID ?? "").trim();
const pixelId = /^[0-9]{5,32}$/.test(rawPixelId) ? rawPixelId : "";

function cookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const prefix = `${name}=`;
  const hit = document.cookie.split(";").map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  return hit ? decodeURIComponent(hit.slice(prefix.length)) : undefined;
}

export function metaEventId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `fk-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function metaBrowserContext(eventId = metaEventId()): MetaBrowserContext {
  return {
    event_id: eventId,
    fbp: cookie("_fbp"),
    fbc: cookie("_fbc"),
    source_url: typeof location === "undefined" ? "https://app.funnelkeeper.com/#/signup" : location.href,
  };
}

export function installMetaPixel(): void {
  if (!pixelId || typeof window === "undefined" || window.fbq) return;
  const fbq: MetaPixel = (...args: unknown[]) => {
    if (fbq.callMethod) fbq.callMethod(...args);
    else {
      fbq.queue = fbq.queue ?? [];
      fbq.queue.push(args);
    }
  };
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  fbq("init", pixelId);
}

export function trackMeta(
  event: "PageView" | "Lead" | "CompleteRegistration",
  properties: Record<string, unknown> = {},
  eventId?: string,
): void {
  if (!pixelId || typeof window === "undefined") return;
  window.fbq?.("track", event, properties, eventId ? { eventID: eventId } : undefined);
}
